<template>
  <div class="AtlasGeoControls">
    <div class="AtlasGeoControls-inner">
      <atlas-geo-controls
        v-if="areGeoSectionsLoaded"
        class="AtlasIndicatorControls-chooseGeo"
        :primary-geo="primaryGeo"
        :geo-sections="geoSections"
        :geo-limit="geoLimit"
        @update:geoType="handleGeoTypeUpdate"
        @update:primaryGeo="handlePrimaryGeoUpdate"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';

import AtlasGeoControls from '../widget/geo-controls.vue';

/**
 * TODO: refactoring
 * Part of indicator controls are geo controls
 * which are implemented in a not-flexible way.
 * <atlas-geo-controls> uses router to update query string parameters,
 * ideally we should listen for 'update:geoType' and 'update:primaryGeo' here
 * and forward data to router query.
 */
export default defineComponent({
  name: 'atlas-geo-controls-standalone',

  components: {
    AtlasGeoControls,
  },

  props: {
    indicatorId: {
      type: String,
      required: true,
    },
    displayRev: {
      type: [String, Number, undefined],
      required: false,
    },

    geoLimit: {
      type: Number,
      default: 1000,
    },
  },

  computed: {
    ...mapGetters('indicator', [
      'geoSections',
      'activeGeoCode',
      'defaultIndicator',
    ]),

    primaryGeo() {
      return (
        this.geoSections
          .flatMap((section) => section.children)
          .find(({ id }) => id === this.activeGeoCode) || {}
      );
    },

    areGeoSectionsLoaded() {
      return this.geoSections && this.geoSections.length;
    },
  },

  methods: {
    ...mapActions({
      fetchIndicatorGeoSelectorOptions:
        'indicator/fetchIndicatorGeoSelectorOptions',
      updateIndicatorGeography: 'indicator/updateGeography',
    }),

    handleGeoTypeUpdate(option) {
      this.updateIndicatorGeography({ geoType: option });

      // fetch missing geo selector options
      this.fetchIndicatorGeoSelectorOptions({
        id: this.indicatorId || this.defaultIndicator,
        displayRev: this.displayRev,
        geoCode: option.id,
      });
    },

    pushQueryToRouter(value, key) {
      this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, [key]: value },
      });
    },

    handlePrimaryGeoUpdate(option) {
      this.updateIndicatorGeography({ geoCode: option });

      this.pushQueryToRouter(option?.id, 'geo');
    },
  },

  mounted() {
    this.fetchIndicatorGeoSelectorOptions({
      id: this.indicatorId || this.defaultIndicator,
      displayRev: this.displayRev,
    });
  },
});
</script>
